<template>
  <section class="thing-settings" @click="disabled = false">
    <form
      class="thing-form"
      :class="{ 'thing-form_open': sidebarOpen }"
      @submit.prevent="saveThing"
    >
      <section class="form-left form-cont">
        <div class="wrap">
          <label class="input-cont input-cont_small"
                 @click="setEditableOn"
                 :class="{'disabled-input': disabled || !isEdit, 'error': $v.name.$error}">
            <p class="label">
              {{$t('roles.filters.name')}}
            </p>
            <input type="text"
                   :readonly="disabled || !isEdit"
                   @blur="onBeingEditing"
                   @focus="$v.name.$reset()"
                   @input="synchronizeTag"
                   v-model="name">
            <errors v-show="$v.name.$error"></errors>
          </label>
          <label class="input-cont input-cont_small"
                 @click="setEditableOn"
                 :class="{'disabled-input': disabled || !isEdit, 'error': $v.tag.$error}">
            <p class="label">
              {{ $t("btns.things.tagName") }}
            </p>
            <input type="text"
                   :readonly="disabled || !isEdit"
                   @blur="onBeingEditing"
                   @input="translateTag"
                   @focus="$v.tag.$reset()"
                   v-model="tag">
            <errors v-show="$v.tag.$error"></errors>
          </label>
        </div>

        <div class="owner-block">
          <div class="owner-head">
            <div class="owner-title">{{$t('things.ownerTitle')}}</div>
          </div>
          <ul class="owner-cont">
            <li>
              <div class="owner-person">
                <div class="avatar-cont"
                     v-if="setOwner('avatar')"
                     :style="{backgroundImage: `url(${setOwner('avatar')})`}"></div>
                <user-icon class="user-icon"
                           v-else></user-icon>
                <p class="star-wrap">
                  {{ setOwner('name') }}
                  <span v-if="setOwner('star')" class="star"><starIcon/></span>
                </p>
              </div>
            </li>
            <li v-for="owner in thingOwners">
              <div class="owner-person">
                <div class="avatar-cont"
                     v-if="owner.user.contacts.avatar_url"
                     :style="{backgroundImage: `url(${owner.user.contacts.avatar_url})`}"></div>
                <user-icon class="user-icon"
                           v-else></user-icon>
                <p v-if="owner.user.first_name"
                   class="star-wrap">
                  {{owner.user.first_name}} <span v-if="owner.user.second_name">{{owner.user.second_name}}</span>
                </p>
                <p v-else class="star-wrap">
                  {{owner.user.contacts.email}}
                </p>
              </div>
              <button v-if="thing.permission_level === 4"
                      type="button"
                      @click="showDelOwner(owner.user.first_name, owner.user.second_name, owner.id)"
                      class="owner-btn hint-cont" >
                <dotsIcon :fill="'rgba(0, 82, 127, .5)'" />
                <p class=" btn-hint  btn-hint_top">
                  {{$t('btns.users.delUser')}}
                </p>
              </button>
            </li>
          </ul>
        </div>

        <div class="tags__block select-cont select-cont_tags">
          <p class="label">{{$t('things.sections.tags.tagsTitle')}}</p>

          <v-select taggable multiple push-tags
                v-model="tags"
                label="name"
                :options="allThingsTags"
                :create-option="tag => ({ name: tag })"
                v-if="!disabled && isEdit">
          </v-select>

          <div class="tags" v-if="disabled || !isEdit">
            <a class="tag" @click="setEditableOn" v-for="tag in tags" :key="tag.id">{{ tag.name }}</a>
            <a class="add__tag" v-if="thing.permission_level > 1" @click="setEditableOn">+ <span>{{$t('things.sections.tags.addNewTag')}}</span></a>
          </div>
        </div>

        <label
          class="textarea-wrap"
          :class="{ 'disabled-input': disabled || !isEdit }"
          @click.stop="setEditableOn();disabled = false">
          <p class="label">
            {{ $t("forms.descLb") }}
          </p>
          <div class="textarea-wrap-desc" v-html="customText" v-show="disabled || !isEdit"></div>
          <vue-editor v-show="!disabled && isEdit"
                      v-model="customText"
                      class="my-editor"
                      useCustomImageHandler
                      :editorOptions="editorSettings"
                      @image-added="uploadEditorImage"
                      @image-removed="removeEditorImage"
                      @selection-change="onBeingEditing"
                      @text-change="textChange"></vue-editor>
        </label>

        <div class="thing-settings__files"
             :class="{ 'disabled-input': disabled || !isEdit }">
          <p class="label">
            {{ $t("forms.filesLb") }}
          </p>
          <div class="thing-settings__files-list">
            <a v-for="(file, indexFile) in files"
               :href="file.path" target="_blank"
               class="thing-settings__files-item">
              <file-icon class="thing-settings__files-icon"/>
              <span>{{ file.name }}</span>
              <button type="button"
                      v-if="thing.permission_level > 2"
                      @click.prevent="removeFile(file.id, indexFile)"
                      class="thing-settings__files-delete">
                <basket-icon/>
              </button>
            </a>
            <div v-if="thing.permission_level > 1" class="thing-settings__files-add">
              <label>
                <plus-icon :fill="'#109CF1'"/>
                <span>Добавить файл</span>
                <input type="file"
                       size="25000000"
                       multiple="multiple"
                       @change="addFiles($event.target.files)">
              </label>
            </div>
          </div>
        </div>

      </section>

      <section class="form-right form-cont"
               :class="{ 'pointer-none': thing.permission_level === 1 }"
      >
        <upload-file :old-img="avatarFile"
                     :disabled="!isEdit"
                     :class="{'avatar-edited': isEdit}"
                     @upload="uploadAvatar($event)"
                     @del="delAvatar"></upload-file>
      </section>

    </form>
  </section>
</template>

<script>
import {singleSettings} from "../../../../mixins/things/singleSettings"
import {filters} from "../../../../mixins/filters"
import {delItem3} from "../../../../mixins/delItem3";
import {showOverlay} from "../../../../mixins/utils/showOverlay";

import addIcon from '../../../Svg/projects/addUser'
import dotsIcon from '../../../../components/Svg/things/dotsIcon'
import starIcon from '../../../Svg/projects/starIcon'
import userIcon from '../../../../components/Svg/users/user'
import fileIcon from "../../../../components/Svg/fileIcon";
import basketIcon from "../../../../components/Svg/basketIcon";
import plusIcon from "../../../../components/Svg/plusIcon";

import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
import {editorConfig} from "@/mixins/editorConfig";
import {required} from 'vuelidate/lib/validators'

import {toFormData} from '../../../../mixins/toFormData'


export default {
    name: 'thingSettings',
    components: {addIcon, dotsIcon, starIcon, userIcon, fileIcon, basketIcon, plusIcon},
    mixins: [singleSettings, filters, showOverlay, delItem3, toFormData, editorConfig],
    data() {
      return {
        name: '',
        tag: '',
        tags: [],
        desc: '',
        editedFields: {},
        avatar: '',
        avatarFile: '',
        usersArray: [],
        usersOwnerArray: [],

        files: [],

        removeFilesIds: '',
        imageUrl: null,
        imageId: '',

        delOwnerId: '',
        textAlignButtons: null
      }
    },
    computed: {
      ...mapState({
        isEdit: state => state.things.onSettingsNodeEdit,
        newAvatar: state => state.things.newAvatar,
        allThingsFromGetOwned: state => state.things.allThingsFromGetOwned,
        nameProfile: state => state.profile.name,
        surnameProfile: state => state.profile.surname,
        avatarProfile: state => state.profile.avatar,
        projects: state => state.projects.allProjects,
        allRoles: state => state.projects.allRoles,
        allThingsTags: state => state.things.allThingsTags
      }),
      ...mapGetters({
        isAdminRole: 'auth/adminRole',
      }),
      thingIsInProject() {
        let marker = false;
        let thingId = this.thing.id;

        for (let project of this.projects) {
          findThing(project.items);
        };

        return marker;

        function findThing(items) {
          findItem(items);

          function findItem(arr) {
            for (let item of arr) {
              for (let thing of item.devices) {
                if (thing.id == thingId) {
                  marker = true;
                }
              };

              if (!marker) {
                findItem(item.items);
              }
            }
          }
        }
      },
      setType() {
        if (this.thing.virtual) {
          return this.$t('things.virtual')
        } else {
          return this.$t('things.thing')
        }
      },
      thingOwners() {
        if (this.thing) {
          let owners = this.thing.permissions.filter(item => item.value > 3);
          for (let role of this.allRoles) {
            for (let owner of owners) {
              if (role.id == owner.role_id) {
                owner.user = role.user;
                break;
              }
            }
          }
          return owners
        }
      }
    },
    methods: {
      ...mapMutations({
        setEditedFields: 'things/SET_ON_EDITING_INPUTS',
        setSettingsNodeEditable: 'things/SET_SETTINGS_NODE_EDITABLE',
        setHeaderSettingsEditActive: 'things/SET_HEADER_SETTINGS_EDIT_ACTIVE',
        showRightsControl: 'things/SET_RIGHTS_CONTROL',
        setRightsType: 'things/SET_RIGHTS_TYPE',

      }),
      ...mapActions({
        setNewAvatar: 'things/setNewAvatar',
        getUsers: 'roles/getUsers',
        removePermission: 'things/removePermission',
        addDeviceFile: 'things/addDeviceFile',
        removeDeviceFile: 'things/removeDeviceFile',
        getProjects: 'projects/getProjects',
        uploadFile: 'global/uploadFile',
      }),
      async uploadEditorImage(file, Editor, cursorLocation) {
        let data = {
          files: file
        }
        let formData = this.toFormData(data)
        await this.uploadFile(formData).then(data => {
          this.imageUrl = data[0].filepath
          this.imageId = data[0].id
          Editor.insertEmbed(cursorLocation, "image", data[0].filepath);
        })
      },
      removeEditorImage(image) {
        let imageTag = document.querySelector(`img[src="${image}"]`);
        if (this.removeFilesIds === '') {
          this.removeFilesIds = imageTag.getAttribute('id');
        } else {
          this.removeFilesIds += ', ' + imageTag.getAttribute('id');
        }
        this.onBeingEditing();
      },
      textChange(delta, oldDelta, source) {
        if (!this.undoRedoFlag) {
          if (this.customText.indexOf(this.imageUrl) !== -1 && this.imageUrl !== null) {
            document.querySelector('.ql-editor').innerHTML = this.customText.replace(this.imageUrl, this.imageUrl + '" id="' + this.imageId + '"')
            this.customText = this.customText.replace(this.imageUrl, this.imageUrl + '" id="' + this.imageId + '"')
            this.imageUrl = null
          }

          this.history.splice(this.position, 1000000)
          this.history.push(this.customText)
          this.position++
        }

        this.undoRedoFlag = false
        this.onBeingEditing()
      },
      addFiles(files) {
        let data = {
          device_id: this.thing.id
        }
        let formData = this.toFormData(data);
        files.forEach((file,index) => {
          formData.append(`files[${index}]`, file)
        });
        this.addDeviceFile(formData).then(res => {
          res.forEach((file) => {
            this.files.push({
              path: file.filepath,
              name: file.filename,
              id: file.id
            })
          })
        });
      },
      removeFile(id, index) {
        let data = {
          device_id: this.thing.id,
          files_ids: String(id)
        }
        this.removeDeviceFile(data).then(res => {
          this.files.splice(index, 1);
        })
      },
      showDelOwner(name, secondName, id) {
        this.showOverlay(true);
        this.showDelPopup(true);
        this.setNumberDel(3);
        this.setDelItems(name + ' ' + secondName);
        this.delOwnerId = id;
      },
      async deleteItems3() {
        this.showLoader()
        await this.removePermission({
          data: {
            ids: JSON.stringify(this.delOwnerId)
          },
          id: this.$route.params.id
        });
        await this.getProjects();
        this.delOwnerId = '';
        this.hideLoader()
      },
      addOwner() {
        this.showOverlay(true);
        this.showRightsControl(true);
        this.setRightsType('owner')
      },
      setOwner(category) {
        let owner;
        let flag = true;

        if (!this.isAdminRole) {
          if (category === 'avatar') {
            return this.thing.owner.user.contacts.avatar_url
          }
          if (category === 'name') {
            return this.thing.owner.user.first_name + ' ' + this.thing.owner.user.second_name
          }
          if (category === 'star') {
            return true
          }
        }

        for (let role of this.allRoles) {
          if (this.thing.owner_role_id === role.id) {
            owner = role.user
            flag = false
          }
        }
        this.usersArray.forEach((user) => {
          if (user.primary_role_id === this.thing.owner_role_id) {
            owner = user
            flag = false
          }
        })

        if (!flag) {
          if (category === 'avatar') {
            return owner.contacts.avatar_url
          }
          if (category === 'name') {
            return owner.first_name + ' ' + owner.second_name
          }
          if (category === 'star') {
            return true
          }
        }

        if (flag) {
          this.allThingsFromGetOwned.forEach((item) => {
            if (item.id === this.thing.id) {
              owner = this.nameProfile + ' ' + this.surnameProfile
            }
          })
          if (category === 'avatar') {
            return this.avatarProfile
          }
          if (category === 'name') {
            return owner
          }
          if (category === 'star') {
            return true
          }
        }
      },
      setEditableNodeSettings(val) {
        this.setSettingsNodeEditable(val);
        this.setHeaderSettingsEditActive(val)
      },
      setEditableOn() {
        if (this.thing.permission_level > 2) {
          this.setEditableNodeSettings(true)
        }
      },
      setEditableOff() {
        this.setEditableNodeSettings(false)
      },
      uploadAvatar(file) {
        this.avatarFile = file;
        this.avatarChanged = true
        this.setNewAvatar(this.avatarFile)
      },
      delAvatar() {
        this.avatarFile = '';
        this.avatarDel = true
        this.setNewAvatar('del')
      },
      onBeingEditing() {
        this.editedFields = {
          name: this.name,
          description: this.customText,
          tags: this.tags,
          system_name: this.tag,
          ids: this.removeFilesIds
        };

        this.editedFields.avatar = this.avatarFile

        this.avatar = this.editedFields.avatar

        this.setEditedFields(this.editedFields)
      },
      setThingParams(val) {
        this.name = val.name;
        this.avatarFile = val.image_url;
        this.tag = val.system_name;
        this.customText = val.description;
        this.tags = val.tags;
      },
      translateTag() {
        this.tag = this.replacer(this.tag)
      },
      synchronizeTag() {
        this.tag = this.replacer(this.name)
      }

    },
    watch: {
      tags() {
        this.onBeingEditing();
      },
      thing(val) {
        if (val) {
          this.setThingParams(val)
          this.files = [ ...this.thing.files ];
        }
      },
      isEdit(val) {
        if (!val) {
          this.setThingParams(this.thing)
          this.removeFilesIds = ''
        }
      }
    },
    validations: {
      name: {
        required
      },
      tag: {
        required
      }
    },
    mounted() {
      this.textAlignButtons = document.querySelectorAll('.ql-align')
      this.textAlignButtons.forEach(btn => {
        btn.onclick = function () {
          let divArr = document.querySelector('#quill-container').childNodes
          divArr[3].style.left = '-2000px'
        }
      })

      if (this.thing) {
        this.setThingParams(this.thing)
      }
      this.getUsers(this.token).then(res => {
        this.usersArray = res
      })
      this.setLabels();
    },
    beforeDestroy() {
      this.setEditableOff()
      this.textAlignButtons.forEach(btn => {
        btn.onclick = function () {
          btn.removeAttribute("onclick")
        }
      })
      this.textAlignButtons = null
    }
  }
</script>

<style lang="scss">
.textarea-wrap {
  ul {
    padding-left: 1.5em;
    list-style: circle;

    li {
      padding-left: 1.5em;
      list-style-type: none;

      &:not(.ql-direction-rtl)::before {
        margin-left: -1.5em;
        margin-right: .3em;
        text-align: right;
      }
      &::before {
        content: '\2022';
      }
      &::before {
        display: inline-block;
        white-space: nowrap;
        width: 1.2em;
      }
    }
  }

  ol {
    padding-left: 3em;
  }

  h6 {
    font-size: .67em;
  }

  h5 {
    font-size: .83em;
  }

  h4 {
    font-size: 1em;
  }

  h3 {
    font-size: 1.17em;
  }

  h2 {
    font-size: 1.5em;
  }

  h1 {
    font-size: 2em;
  }

  .textarea-wrap-desc {
    p {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  img {
    max-width: 100%;
  }

  .my-editor iframe {
    pointer-events: none;
  }
}

blockquote {
  border-left: 4px solid #ccc;
  margin: 5px 0 5px 0;
  padding: 0 0 0 16px;
}
</style>

<style lang="scss" scoped>
  input {
    max-height: 40px;
  }

  .thing-form {
    display: flex;
    justify-content: space-between;
    height: 100%;

    .form-right {
      max-width: 220px;
      width: 100%;

      .drug-field {
        padding: 0 14px !important; //?????????????
      }
    }

    .form-left {
      width: calc(100% - 40px - 220px);
      margin-right: 40px;
      height: 100%;
      display: flex;
      flex-direction: column;
      min-height: calc(100vh - 210px - 80px - 20px);
    }

    .label {
      font-size: 13px;
    }
  }

  .thing-settings__files-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 18px 17px;
    background: #FFFFFF;
    border-radius: 8px;

    .thing-settings__files-item {
      display: flex;
      align-items: center;
      max-width: 300px;
      padding: 11px 17px;
      border-radius: 12px;
      transition: $anim;

      span {
        overflow: hidden;
        text-overflow: ellipsis;
        color: #00527F;
      }

      .thing-settings__files-icon {
        min-width: 18px;
        max-width: 18px;
        height: 22px;
        margin-right: 11px;
      }

      .thing-settings__files-delete {
        margin-left: 11px;
        opacity: 0;
        transition: $anim;

        svg {
          min-width: 15px;
          max-width: 15px;
          height: 16px;
        }

      }

      &:hover {
        background: #E9F0F4;

        .thing-settings__files-delete {
          opacity: 1;
        }
      }
    }

    .thing-settings__files-add {
      display: flex;
      width: 100%;
      padding: 11px 17px;

      label {
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;

        svg {
          width: 14px;
          height: 14px;
          margin-right: 11px;
          transition: $anim;
        }

        span {
          font-size: 14px;
          color: #109CF1;
        }

        input {
          position: absolute;
          top: 0;
          opacity: 0;
          z-index: -1;
        }

        &:hover {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    }
  }

  .thing-form_open {
    padding: 0 20px;
  }

  /*.input-cont {*/
  /*  margin-bottom: 20px;*/
  /*}*/

  .btn-blue {
    margin-top: auto;
    max-width: 140px;

    &:disabled {
      background: none;
      color: $darkBlue;
      border: 1px solid $darkBlue;;
      opacity: .3;
    }
  }

  .btn-blue.loading {
    background: $lightBlue;
    opacity: 1;
    border-color: $lightBlue;
  }

  .thing-settings {
    height: 100%;
  }

  .textarea-wrap textarea {
    min-height: 230px;
    resize: none;
  }

  .textarea-wrap {
    position: relative;
    margin-bottom: 16px;
    padding-bottom: 16px;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: #D7E3EA;
    }
  }

  .wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #D7E3EA;
    padding-bottom: 16px;
    margin-bottom: 16px;

    .input-cont {
      width: calc(50% - 10px);
      /*width: 240px;*/
    }
  }

  //выравнивание отключенных инпутов
  input[readonly], textarea[readonly] {
    transform: translateX(-14px);
  }

  .owner-block {
    border-bottom: 1px solid $grey;
    margin-bottom: 16px;

    .owner-head {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
    }

    .add-new-owner {
      font-family: $mm;
      font-size: 10px;
      color: $lightBlue;
      display: flex;
      align-items: center;

      svg {
        margin-left: 10px;
      }

    }
  }
  .owner-cont {
    font-size: 14px;
    color: $darkBlue;

    .owner-person {
      display: flex;
      align-items: center;

      .avatar-cont, .user-icon {
        border-radius: 50%;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
      }

      .user-icon {
        //если нет иконки у пользователя, иначе обрезается внизу
        border-radius: 0;
        width: 18px;
      }
    }

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    .owner-btn svg {
      width: 20px;
      height: 20px;
      transition: $anim;
      border-radius: 50%;

      &:hover {
        background: $grey;
      }
    }
  }

  .owner-title,
  .tags-head {
    font-size: 13px;
    color: rgba(0, 82, 127, .5);
  }

  .star-wrap {
    position: relative;
    .star {
      position: absolute;
      right: -12px;
      top: -5px;
    }
  }

/* Tags */

.tags__block {
  margin-bottom: 16px;
  border-bottom: 1px solid #D7E3EA;

  .label {
    opacity: 0.5;
    margin-bottom: 10px;
  }

  .tags {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: 0 -8px 8px 0;

    .tag {
      font-family: MR, Arial, sans-serif;
      font-size: 14px;
      color: #109cf1;
      margin: 0 8px 8px 0;
      padding: 5px 11px 3px;
      border: 0.5px solid #109cf1;
      border-radius: 6px;
      transition: all 0.25s ease-in-out;
      letter-spacing: 0.25px;
      cursor: pointer;

      &:hover {
        color: #fff;
        background: #109cf1;
        box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
      }
    }

    .add__tag {
      font-family: MR, Arial, sans-serif;
      font-size: 14px;
      color: #109cf1;
      margin-bottom: 8px;
      text-decoration: none;
      cursor: pointer;

      span {
        text-decoration: underline;
      }

      &:hover span {
        text-decoration: none;
      }
    }
  }
}
.pointer-none {
  pointer-events: none;
}
</style>
